/* @flow */

import { isObject } from '@e180/util/lib/type';

export function isHTTP4xxError(error: Error): boolean {
  // $FlowIssue
  const { response } = error;

  if (isObject(response)) {
    const { status } = response;

    return status >= 400 && status < 500;
  }

  return false;
}
